<template>
  <div>
    <h2>{{titulo}}</h2>
    <DataTable
      :loading="loading"
      :columns="columns"
      :rows="rows"
      :paging=false
      :buttons=false
      :searching="false"
      :td-style-class="tdStyleClassFn"
      clases="table-bordered nowrap">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'p_c'">
          {{ porcentaje(props.row.c, props.row.t) }}%
        </span>
        <span v-else-if="props.column.field == 'p_pa'">
          {{ porcentaje(props.row.p, props.row.t) }}%
        </span>
        <span v-else-if="props.column.field == 'p_nc'">
          {{ porcentaje(props.row.n, props.row.t) }}%
        </span>
        <span v-else-if="props.column.field == 't'">
          {{ props.row.t }}
        </span>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { programaService } from '@/services';

export default {
  props:['titulo'],
  data(){
    return {
      loading: true,
      columns:[
        {label: 'Programa', field: 'nombre_programa'},
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Completado', field: 'p_c'},
        {label: 'En proceso', field: 'p_pa'},
        {label: 'No realizado', field: 'p_nc'},
        {label: 'Tareas programadas', field: 't'},
        ],
      rows:[],
    }
  },
  mounted(){
    this.cargarDatos();
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      programaService.getProgramaWidgetTablaAvance({
        id_usuario: this.$store.state.usuario.id_usuario,
        perfiles: this.$store.state.usuario.perfiles.map((element) => element.id_perfil)
      }).then(data => {
        this.rows = data.data;

        this.loading = false;
      });
    },
    tdStyleClassFn(row, column) {
      if(column.field == 'p_pa'){
        return "td-yellow";
      }
      if(column.field == 'p_nc'){
        return "td-red";
      }
      if(column.field == 'p_c' || column.field == 't'){
        return "td-green";
      }
    },
    porcentaje(valor, total){
      total = total == 0 ? 1 : total;
      let porcentaje = (valor*100)/ total;
      return Math.round(porcentaje*100)/100;
    }
  }
}
</script>

<style scoped>
</style>
